import type { ComponentDefinition } from '@wix/platform-editor-sdk';

import { shouldUseScalableDimensionsForLoginBarOnE3 } from '../../../../utils/experiments';
import { E3_LOGIN_BAR_COMPONENT_REF } from '../../../constants';
import { COMMON_LOGIN_COMP_CONNECTIONS_V2 } from './common-login-bar-layouts';
import { LOGIN_COMP_RESPONSIVE_APP_WIDGET } from './responsive-login-bar-layouts';

const getLoginBarEditor3CompDef = async () => {
  const useScalableDimensions = await shouldUseScalableDimensionsForLoginBarOnE3();

  return {
    componentType: E3_LOGIN_BAR_COMPONENT_REF,
    layout: {
      width: 110,
      height: 40,
      x: 740,
      y: 24,
    },
    connections: COMMON_LOGIN_COMP_CONNECTIONS_V2,
    layoutResponsive: {
      type: 'LayoutData',
      componentLayouts: [
        {
          type: 'ComponentLayout',
          ...(useScalableDimensions
            ? {
                width: { type: 'spx', value: 110 },
                height: { type: 'spx', value: 40 },
              }
            : {
                width: { type: 'px', value: 110 },
                height: { type: 'px', value: 40 },
                minHeight: { type: 'px', value: 40 },
              }),
        },
      ],
      itemLayouts: LOGIN_COMP_RESPONSIVE_APP_WIDGET.layoutResponsive.itemLayouts,
      containerLayouts: [],
    },
  } as unknown as ComponentDefinition;
};

export { getLoginBarEditor3CompDef };
